import React from 'react';
import Dialog from 'material-ui/Dialog';
import FontIcon from 'material-ui/FontIcon'
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';


export default class HousingGroupModal extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        onTouchTap={this.handleClose}
      />
    ];

    return (
      <div className="right-float">
        <FontIcon onTouchTap={this.handleOpen} className="material-icons help_outline right-float">help</FontIcon>

        <Dialog
          title="Housing Group Guide"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
        <div className="modal-summary">
            <p>Invite friends to form a group or create a single</p>
        </div>
        <p><b>Your Lottery Number</b> - This is your personal lottery number that tells you where you’re ranked within your grade.</p>
        <p><b>Group Lottery Number</b> - This the lottery number for your entire group, chosen from the lowest lottery number in the group.</p>
        <p><b>Groups you have created</b> - Here’s where all the information about your group’s status lives. Remember, if anyone rejects your invitation, your group will be disbanded.</p>
        <p><b>Confirmed Group</b> - Check here to see that you’re in a confirmed group. Without being in a confirmed group, you can browse rooms but not add or rank preferences.</p>
        <p><b>Group Invites</b> - Be careful when accepting or rejecting invites. If you accept, you’re locked into that group if it gets confirmed. If you reject, the group will be disbanded. Note that you must respond to any invites before other groups can invite you.</p>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/components/modals/housing-group-modal.js